import type { Theme } from '@material-ui/core';
import { createTheme as createMuiTheme } from '@material-ui/core';

export const shade = {
  '1000': '#000000',
  '900': '#1A1A1A',
  '800': '#333333',
  '700': '#4D4D4D',
  '600': '#666666',
  '500': '#808080',
  '400': '#999999',
  '300': '#B3B3B3',
  '200': '#CCCCCC',
  '100': '#E6E6E6',
  '50': '#F2F2F2',
  '25': '#F9F9F9',
  '0': '#FFFFFF',
} as const;

export const shadeArray = Object.values(shade);

const erplyLadna = 'Erply-Ladna';
const createTheme = (isDarkMode: boolean): Theme => {
  const { palette } = createMuiTheme({
    shade,
    palette: {
      type: isDarkMode ? 'dark' : 'light',
      primary: { main: '#3D94F6', light: '#F5FAFA' },
      secondary: { main: '#EEA941' },
      tertiary: { main: '#29689F' },
      warning: { main: '#FFF998' },
      error: { main: '#FF6262' },
      divider: 'rgb(255,255,255,0.2)',
    },
  });
  return createMuiTheme({
    isDarkMode,
    shade,
    palette,
    typography: {
      fontFamily: [erplyLadna, 'Roboto', 'serif'].join(','),
      h1: {
        fontWeight: 90,
        fontSize: '96px',
        lineHeight: '112px',
      },
      h2: {
        fontWeight: 90,
        fontSize: '72px',
        lineHeight: '80px',
      },
      h3: {
        fontWeight: 'normal',
        fontSize: '48px',
        lineHeight: '56px',
      },
      h4: {
        fontWeight: 105,
        fontSize: '36px',
        lineHeight: '38px',
      },
      h5: {
        fontWeight: 120,
        fontSize: '36px',
        lineHeight: '38px',
      },
      h6: {
        fontWeight: 130,
        fontSize: '24px',
        lineHeight: '30px',
      },
      subtitle1: {
        fontWeight: 105,
        fontSize: '20px',
        lineHeight: '24px',
      },
      subtitle2: {
        fontWeight: 90,
        fontSize: '16px',
        lineHeight: '24px',
      },
      body1: {
        fontWeight: 105,
        fontSize: '16px',
        lineHeight: '24px',
      },
      body2: {
        fontWeight: 105,
        fontSize: '14px',
        lineHeight: '20px',
      },
      button: {
        fontWeight: 140,
        fontSize: '14px',
        lineHeight: '16px',
        letterSpacing: '0.015em',
        textTransform: 'uppercase',
      },
      caption: {
        fontWeight: 105,
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0.01em',
      },
      overline: {
        fontWeight: 105,
        fontSize: '10px',
        lineHeight: '10px',
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
      },
    },
    overrides: {
      MuiOutlinedInput: {
        root: {
          borderRadius: 0,
        },
      },
      MuiInput: {
        root: {
          fontFamily: erplyLadna,
        },
      },
      MuiLink: {
        root: {
          fontFamily: erplyLadna,
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '16px',
          lineHeight: '24px',
          letterSpacing: '0.005em',
          color: '#008CC0',
        },
      },
      MuiButton: {
        root: {
          borderRadius: 0,
        },
        contained: {
          boxShadow: 'none',
        },
      },
    },
  });
};

export default createTheme;
